<template>
  <div>
    <video :src="voteOption.video" v-if="voteOption.video" class="video" controls></video>
    <div v-html="voteOption.description"></div>
    <div class="content">
      <div class="form">
        <div class="title">演讲比赛评分</div>
        <div class="vote-item" v-for="(item,index) in votes" :key="index">
          <div class="item-title">{{item.title}}</div>
          <van-cell-group>
            <van-field
              v-model="item.score"
              type="digit"
              :placeholder="'请打分输入，如“'+item.max+'”'"
              class="input"
              :class="{invalid: item.invalid}"
            />
          </van-cell-group>
        </div>
        <div>总分：{{sumScore}}</div>
        <div @click="vote" class="vote-btn" v-if="canSubmit">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Notify, Dialog } from "vant";
export default {
  name: "",
  computed: {
    sumScore() {
      var sum = 0;
      this.votes.map(item => {
        if (item.score) {
          sum += parseInt(item.score);
        }
      });
      return sum;
    }
  },
  data() {
    return {
      voteOption: {},
      canSubmit: false,
      votes: [
        { title: "1、主题鲜明、标题醒目（5分）", max: 5 },
        { title: "2、观点正确、角度新颖、题材典型（10分）", max: 10 },
        { title: "3、事、情、理交融，逻辑严谨，说服力强（5分）", max: 5 },
        { title: "4、文笔（10分）", max: 10 },
        {
          title: "5、普通话标准，口齿清晰，语音纯正（10分）",
          max: 10
        },
        {
          title:
            "6、语言生动、语气、语调、声音、节奏富于变化，轻重缓急，抑扬顿挫且符合演讲内容（20分）",
          max: 20
        },
        {
          title:
            "7、肢体动作、表情能准确、直观、灵活地表达演讲内容和思想感情（10分）",
          max: 10
        },
        {
          title:
            "8、演讲精彩有力，使人在美的享受中收到了深刻教育，具有强大的鼓舞性、激励性、说服力、感召力和召唤力（10分）",
          max: 10
        },
        {
          title: "9、体现演讲者口头表达能力（10分）",
          max: 10
        },
        {
          title:
            "10、时间限制为5分钟，若超时或少时，每分钟扣2分，扣完10分为止（10分）",
          max: 10
        }
      ]
    };
  },
  mounted() {
    this.checkPass();
    this.getOption();
  },
  methods: {
    checkPass() {
      if (!this.$store.state.customization.zhejiangPass) {
        this.$router.push({ name: "jinrongtoupiao" });
      }
    },
    getOption() {
      this.$reqGet(
        "api/customization/zhejiang_jinrong/voteOption/" +
          this.$route.params.id,
        { user: this.$store.state.customization.zhejiangPass }
      ).then(res => {
        this.voteOption = res.data.data.option;
        if (res.data.data.vote) {
          this.votes = res.data.data.vote.raw;
        } else {
          this.canSubmit = true;
        }
      });
    },
    vote() {
      var valid = true;
      this.votes.map(item => {
        var itemValid = true;
        if (!item.score) {
          itemValid = false;
        } else if (parseInt(item.score) > item.max) {
          itemValid = false;
        }
        this.$set(item, "invalid", !itemValid);
        if (!itemValid) {
          valid = false;
        }
      });
      if (!valid) {
        Notify("请检查错误项");
      } else {
        this.submit();
      }
    },
    submit() {
      this.$reqPost("api/customization/zhejiang_jinrong/vote", {
        vote_option_id: this.$route.params.id,
        user: this.$store.state.customization.zhejiangPass,
        raw: this.votes,
        score: this.sumScore
      }).then(res => {
        Dialog.alert({
          title: "提示",
          message: "保存成功"
        }).then(res => {
          this.$router.back();
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.video {
  width: 100%;
  display: block;
  height: auto;
}
.content {
  background: #c30000;
  padding: 15px;
}
.form {
  background: #fff;
  padding: 10px;
}
.title {
  color: #c30000;
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}
.item-title {
  margin: 10px 0;
}
.vote-btn {
  background: #c30000;
  border-radius: 6px;
  margin: 20px auto;
  text-align: center;
  padding: 13px;
  color: #fff;
}
.input {
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.input.invalid {
  border-color: #c30000;
}
</style>